import { createFileRoute } from "@tanstack/react-router";
import { OverviewScreen } from "./-overview/OverviewScreen";

export const Route = createFileRoute("/admin/")({
  staticData: { title: "Overview" },
  component: OverviewScreen,
});
